import React, { useState } from 'react';
import styles from './ChoiceCard.module.css';
import type { ForemanChoice } from '../../types/foreman';

interface ChoiceCardProps {
  choice: ForemanChoice;
  onSelect?: (option: string) => void;
}

const ChoiceCard: React.FC<ChoiceCardProps> = ({ choice, onSelect }) => {
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (option: string) => {
    setSelected(option);
    onSelect?.(option);
  };

  return (
    <div className={styles.card}>
      <div className={styles.title}>{choice.title}</div>
      {choice.description && (
        <div className={styles.description}>{choice.description}</div>
      )}
      <div className={styles.options}>
        {choice.options.map((option, idx) => (
          <button
            key={idx}
            type="button"
            className={`${styles.option} ${selected === option ? styles.selected : ''}`}
            onClick={() => handleSelect(option)}
          >
            <span className={styles.radio}>
              <span className={styles.radioDot} />
            </span>
            <span className={styles.optionLabel}>{option}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChoiceCard;
